import {html, PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@cbar/cbar-dropdown/cbar-dropdown';
import '@cbar/cbar-date-time-picker/cbar-date-time-picker';
import {RecursiveValidate} from "@cbar/cbar-recursive-validate-mixin";

/**
 * `cbar-relationship-selector`
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarRelationshipSelector extends RecursiveValidate(PolymerElement) {
  static get template() {
    return html`
      <style>
        :host {
          display: block;
        }

        cbar-date-time-picker {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }

        cbar-dropdown {
          width: 100%;
        }
      </style>

      <cbar-dropdown
        id="relationshipDropdown"
        label="[[relationshipsLabel]]"
        items="[[relationships]]"
        on-change="onRelationshipChanged"
        value="[[selectedRelationship.id]]"
        required$="[[required]]" 
        disabled$="[[disabled]]"
        fixedMenuPosition$=[[fixedMenuPosition]]
      >
      </cbar-dropdown>

      <template is="dom-if" if="[[showStartDate]]">
        <cbar-date-time-picker
          id="startDatePicker"
          date="{{selectedStartDate}}"
          show-label-buttons 
          disabled$="[[disabled]]">
          <span slot="label">Start</span>
        </cbar-date-time-picker>
      </template>

      <template is="dom-if" if="[[showEndDate]]">
        <cbar-date-time-picker
          id="endDatePicker"
          date="{{selectedEndDate}}"
          min-date="[[selectedStartDate]]" 
          disabled$="[[disabled]]"
          show-label-buttons>
          <span slot="label">End</span>
        </cbar-date-time-picker>
      </template>
    `;
  }

  static get properties() {
    return {
      /**
       * An array of CBAR relationships
       */
      relationships: {
        type: Array,
        value: [],
      },

      /**
       * The currently selected relationship in the dropdown
       */
      selectedRelationship: {
        type: Object,
        notify: true,
        observer: '_selectedRelationshipChanged',
      },

      /**
       * Whether a relationship is required to be selected.
       * Use in conjunction with the validate() method or an iron-form
       */
      required: {
        type: Boolean,
        value: false,
      },

      /**
       * Whether to show the start date picker for the relationship
       */
      showStartDate: {
        type: Boolean,
        value: true,
      },

      /**
       * Whether to show the end date picker for the relationship
       */
      showEndDate: {
        type: Boolean,
        value: false,
      },

      /**
       * The currently selected start date for the selected relationship
       */
      selectedStartDate: {
        type: Date,
        notify: true,
      },

      /**
       * The currently selected start date for the selected relationship
       */
      selectedEndDate: {
        type: Date,
        notify: true,
      },

      /**
       * The label to display on the relationships dropdown
       */
      relationshipsLabel: {
        type: String,
        value: "Relationships",
      },

      fixedMenuPosition: {
        type: Boolean,
        value: false,
      },

      staticTime: {
        type: Boolean,
        value: false
      },
      disabled: {
        type: Boolean,
        value: false
      }
    };
  }

  onRelationshipChanged(e) {
    const id = e.target.value;
    if (!id) {
      this.selectedRelationship = null;
    }

    this.selectedRelationship = this.relationships.find(r => r.id.toString() === id.toString());
  }

  _selectedRelationshipChanged(selectedRelationship) {
    // only allow users to edit this manually, no automatic update
    if(this.staticTime && this.selectedStartDate){
      return;
    }

    if (selectedRelationship) {
      if (selectedRelationship.hasOwnProperty('startTime')) {
        this.selectedStartDate = selectedRelationship.startTime;
      }else {
        this.selectedStartDate = null;
      }

      if (selectedRelationship.hasOwnProperty('endTime')) {
        this.selectedEndDate = selectedRelationship.endTime;
      }else {
        this.selectedEndDate = null;
      }
    }
  }
}

window.customElements.define('cbar-relationship-selector', CbarRelationshipSelector);
